import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
    (r) => r,
    async (error) => {
        const { config, response } = error;
        if (response?.status === 401 && config && !config._retried && !config.url.includes("/auth/")) {
            config._retried = true;
            refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
            try {
                await refreshing;
                return api(config);
            } catch {
                /* session gone */
            }
        }
        return Promise.reject(error);
    },
);

export function apiError(e) {
    const detail = e?.response?.data?.detail;
    if (detail == null) return e?.message || "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
